module.exports = "/build/web/images/work-method-quotation.23d0b7d9adfedabcf83b8869d46f79fb.png";


//////////////////
// WEBPACK FOOTER
// ./images/work-method-quotation.png
// module id = 138
// module chunks = 11